/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import jwt from "../../http/requests/auth/jwt/index.js"


import firebase from 'firebase/app'
import 'firebase/auth'
import router from '@/router'
import axios from "@/axios.js"

export default {
    loginAttempt({ dispatch }, payload) {
        // New payload for login action
        const newPayload = {
            userDetails: payload.userDetails,
            notify: payload.notify,
            closeAnimation: payload.closeAnimation
        }
        // If remember_me is enabled change firebase Persistence
        if (!payload.checkbox_remember_me) {
            // Change firebase Persistence
            firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
                // If success try to login
                .then(function() {
                    dispatch('login', newPayload)
                })
                // If error notify
                .catch(function(err) {
                    // Close animation if passed as payload
                    if(payload.closeAnimation) payload.closeAnimation()
                    payload.notify({
                        time: 2500,
                        title: 'Error',
                        text: err.message,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                })
        } else {
            // Try to login
            dispatch('login', newPayload)
        }
    },

    // Google Login
    loginWithGoogle({commit, state}, payload) {
        if (state.isUserLoggedIn()) {
            payload.notify({
                title: 'Login Attempt',
                text: 'You are already logged in!',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            })
            return false
        }
        const provider = new firebase.auth.GoogleAuthProvider()

        firebase.auth().signInWithPopup(provider)
          .then((result) => {
              router.push(router.currentRoute.query.to || '/')
              commit('UPDATE_USER_INFO', result.user.providerData[0], {root: true})
          }).catch((err) => {
              payload.notify({
                  time: 2500,
                  title: 'Error',
                  text: err.message,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
              })
          })
    },

    // Facebook Login
    loginWithFacebook({commit, state}, payload) {
        if (state.isUserLoggedIn()) {
            payload.notify({
                title: 'Login Attempt',
                text: 'You are already logged in!',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            })
            return false
        }
        const provider = new firebase.auth.FacebookAuthProvider()

        firebase.auth().signInWithPopup(provider)
            .then((result) => {
                router.push(router.currentRoute.query.to || '/')
                commit('UPDATE_USER_INFO', result.user.providerData[0], {root: true})
            }).catch((err) => {
                payload.notify({
                    time: 2500,
                    title: 'Error',
                    text: err.message,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
    },

    // Twitter Login
    loginWithTwitter({commit, state}, payload) {
        if (state.isUserLoggedIn()) {
            payload.notify({
                title: 'Login Attempt',
                text: 'You are already logged in!',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            })
            return false
        }
        const provider = new firebase.auth.TwitterAuthProvider()

        firebase.auth().signInWithPopup(provider)
            .then((result) => {
                router.push(router.currentRoute.query.to || '/')
                commit('UPDATE_USER_INFO', result.user.providerData[0], {root: true})
            }).catch((err) => {
                payload.notify({
                    time: 2500,
                    title: 'Error',
                    text: err.message,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
    },

    // Github Login
    loginWithGithub({commit, state}, payload) {
        if (state.isUserLoggedIn()) {
            payload.notify({
                title: 'Login Attempt',
                text: 'You are already logged in!',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            })
            return false
        }
        const provider = new firebase.auth.GithubAuthProvider()

        firebase.auth().signInWithPopup(provider)
            .then((result) => {
                router.push(router.currentRoute.query.to || '/')
                commit('UPDATE_USER_INFO', result.user.providerData[0], {root: true})
            }).catch((err) => {
                payload.notify({
                    time: 2500,
                    title: 'Error',
                    text: err.message,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
    },

    registerUser({dispatch}, payload) {

        // create user using firebase
        firebase.auth().createUserWithEmailAndPassword(payload.userDetails.email, payload.userDetails.password)
            .then(() => {
                payload.notify({
                    title: 'Account Created',
                    text: 'You are successfully registered!',
                    iconPack: 'feather',
                    icon: 'icon-check',
                    color: 'success'
                })
                const newPayload = {
                    userDetails: payload.userDetails,
                    notify: payload.notify,
                    updateUsername: true
                }
                dispatch('login', newPayload)
            }, (error) => {
                payload.notify({
                    title: 'Error',
                    text: error.message,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
    },
    updateUsername({commit}, payload) {
      return new Promise((resolve, reject) => {
        axios.post("/api/user/update", payload)
          .then((response) => {
            if(response.data.result == 'success'){
              commit('UPDATE_USER_INFO', response.data.userData, {root: true})
              resolve(response)
            }
          }).catch((error) => {
            reject(error)
        })
      })
    },
    // JWT
    loginJWT({commit }, payload) {
      return new Promise((resolve,reject) => {
        jwt.login(payload.userDetails.email, payload.userDetails.password)
          .then(response => {
            // If there's user data in response
            if(response.data.result == 'success') {
              // Set Token & ID
              commit('UPDATE_USER_INFO', response.data.userData, {root: true})
              if (payload.checkbox_remember_me){
                localStorage.setItem("filleduToken", response.data.token)
                // commit('SET_LOCALSTORAGE_USER_INFO', response.data.userData, {root: true})
              } else{
                sessionStorage.setItem("filleduToken", response.data.token)
                // commit('SET_SESSIONSTORAGE_USER_INFO', response.data.userData, {root: true})
              }
              // Set bearer token in axios
               sessionStorage.setItem("filleduToken", response.data.token)
               // commit('SET_SESSIONSTORAGE_USER_INFO', response.data.userData, {root: true})
              commit("SET_BEARER", response.data.token)
              resolve(response)
            }else {
              reject({message: "Wrong Email or Password"})
            }
          })
          .catch(error => { reject(error) })
      })
    },
    deleteUser(){
      return new Promise((resolve, reject) => {
        axios.delete("/api/user")
          .then((response) => {
            resolve(response)
          }).catch((error) => {
            reject(error)
        })
      })
    },
    registerUserJWT({ commit }, payload) {
      const { displayName, email, password, confirmPassword } = payload.userDetails
      return new Promise((resolve,reject) => {
        // Check confirm password
        if(password !== confirmPassword) {
          reject({message: "Password doesn't match. Please try again."})
        }
        jwt.registerUser(displayName, email, password)
          .then(response => {
            // Redirect User
            router.push(router.currentRoute.query.to || '/apps/space')
            // Update data in localStorage
            localStorage.setItem("filleduToken", response.data.token)
            commit('UPDATE_USER_INFO', response.data.userData, {root: true})
            resolve(response)
          })
          .catch(error => { reject(error) })
      })
    },
    fetchAccessToken() {
      return new Promise((resolve, reject) => {
        jwt.refreshToken().then(response => {
          if(response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        }).catch((error) => { reject(error) })
      })
    },
    // validatino email
    checkUserEmail(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post("/api/user-email/validation", {"email": payload.email})
          .then((response) => {
            // commit("SET_UNREAD", payload)
            // Remove this if you are getting meta like us
            // Use your own method to update email meta if you are fetching email meta
            // commit("UPDATE_UNREAD_META", payload)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    createUser(context, payload){
      var userInfo = {"name": payload.name, "email": payload.email}
      return new Promise((resolve, reject) => {
        axios.post("/api/user/create", userInfo)
          .then((response) => {
            // commit("SET_UNREAD", payload)
            // Remove this if you are getting meta like us
            // Use your own method to update email meta if you are fetching email meta
            // commit("UPDATE_UNREAD_META", payload)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    findPasswrod(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post("/api/user/password/find", payload)
        .then((response) => {
          if(response.data.result == "success"){
            resolve(response)
          }
          reject(response)
        }).catch((error) => { reject(error) })
      })
    },
    changePassword({ commit }, payload){
      var userInfo = {"email": payload.email, "password": payload.password, "new_password": payload.newPassword}
      return new Promise((resolve, reject) => {
        axios.post("/api/user/change-pw", userInfo)
        .then((response) => {
          if(response.data.result == "success"){
            localStorage.setItem("filleduToken", response.data.token)
            // localStorage.setItem("filleduUserInfo", response.data.userData[0])
            // Navigate User to homepage
            // Update user details
            commit('UPDATE_USER_INFO', response.data.userData, {root: true})
            // Set bearer token in axios
            commit("SET_BEARER", response.data.token)
            resolve(response)
          }else {
            reject(response)
          }
        })
        .catch((error) => { reject(error) })
      })
    },
    loginChangePassword(context, payload) {
      // changePasswordInfo의 password 값을 payload.password에서 payload.confirm_password로
      return new Promise((resolve, reject) => {
        axios.post("/api/user/login/change-pw", payload)
        .then((response) => {
          if(response.data.result == "success"){
            resolve(response)
          }
          reject(response)
        }).catch((error) => { reject(error) })
      })
    },
    inviteAccept(context, payload){
      return new Promise((resolve, reject) => {
        axios.post("/api/invite", payload)
        .then((response) => {
          if(response.data.result == "success"){
            resolve(response)
          } else {
            reject(response)
          }
        }).catch((error) => { reject(error) })
      })
    }
}
